import { Link } from "react-router-dom";
import { categories, getArticlesByCategory } from "../../../mocks/news";
import SectionTitle from "../../../components/base/SectionTitle";

export default function CategoryStrip() {
  return (
    <section className="border-y border-background-300/60 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <SectionTitle eyebrow title="按栏目逛" linkLabel="" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
          {categories.map((c, i) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative overflow-hidden rounded-xl"
            >
              <img
                src={c.cover}
                alt={c.name}
                title={`${c.name} - 每日爆料网`}
                className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-52"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
              <span className="absolute right-4 top-4 font-serif text-5xl font-black text-background-50/20">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <p className="text-xs text-background-100/80">{c.tagline}</p>
                <h3 className="mt-1 flex items-center gap-2 font-serif text-xl font-black text-background-50">
                  {c.name}
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
                </h3>
                <p className="mt-1.5 line-clamp-1 text-xs text-background-100/85">{c.desc}</p>
                <p className="mt-2 text-xs text-accent-300">
                  {getArticlesByCategory(c.slug).length} 篇精选内容
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}